/** Clair / sombre + 12 accents, ou Aurélia+ (palette fixe). */
import { useEffect, useRef, useState } from "react";
import { FX_ACCENT_IDS, FX_ACCENTS } from "./accents";
import { useFxTheme } from "./ThemeProvider";
import "./themeMenu.css";

export function ThemeMenu() {
  const { theme, accent, setTheme, setAccent } = useFxTheme();
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLDivElement>(null);
  const current = FX_ACCENTS[accent];

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!box.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="fx-theme" ref={box}>
      <button
        type="button"
        className="fx-iconbtn fx-theme__btn"
        aria-expanded={open}
        aria-label={
          theme === "plus" ? "Thème — Aurélia+" : `Thème — ${theme === "dark" ? "sombre" : "clair"}, ${current.label}`
        }
        onClick={() => setOpen((v) => !v)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      </button>
      {open ? (
        <div className="fx-theme__panel" role="dialog" aria-label="Thème">
          <p className="fx-theme__kicker">Apparence</p>
          <div className="fx-theme__switch">
            <button type="button" className={theme === "light" ? "is-on" : ""} onClick={() => setTheme("light")}>
              Clair
            </button>
            <button type="button" className={theme === "dark" ? "is-on" : ""} onClick={() => setTheme("dark")}>
              Sombre
            </button>
            <button
              type="button"
              className={`fx-theme__plus${theme === "plus" ? " is-on" : ""}`}
              onClick={() => setTheme("plus")}
            >
              Aurélia+
            </button>
          </div>
          {theme === "plus" ? (
            <p className="fx-theme__label">Bleu néon → violet électrique</p>
          ) : (
            <>
              <p className="fx-theme__kicker">Couleur</p>
              <div className="fx-theme__swatches" role="listbox" aria-label="Couleur d’accent">
                {FX_ACCENT_IDS.map((id) => (
                  <button
                    key={id}
                    type="button"
                    role="option"
                    aria-selected={accent === id}
                    title={FX_ACCENTS[id].label}
                    className={accent === id ? "is-on" : ""}
                    style={{ background: FX_ACCENTS[id].swatch }}
                    onClick={() => setAccent(id)}
                  />
                ))}
              </div>
              <p className="fx-theme__label">{current.label}</p>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
}
